// extracted by mini-css-extract-plugin
export default {"authform":"Authorization_authform__RcILs","h2":"Authorization_h2__GJtU1"};